import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { c as m } from "./clsx.OuTLNxxd.js";
const s = i(
  ({ children: o, className: r, ...t }, n) => /* @__PURE__ */ e("button", { ref: n, className: m("neu-link overflow-hidden px-0", r), ...t, children: o })
);
s.displayName = "LinkButton";
export {
  s as L
};
